module.exports = Jsw.skinUrl + "/images/notification-center-empty.svg?43fc5fb492a0c4f20cf8099df726cf83";